<template>
  <div class="row product-settings">
    <div class="col" v-if="product">
      <div class="row">
            <div class="col">
                <div class="d-flex product-settings-actions align-items-center justify-content-between">
                    <router-link class="btn btn-back btn-lg" :to="backLink" tag="button">
                        <i class="fa fa-angle-left px-1"></i>
                    </router-link>
                    <h2 class="ml-4">{{product.name}}</h2>
                    <div class="d-flex">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
         <div class="row product-setting-group mt-4">
            <div class="col mr-3 product-settings-options">
              <div class="product-settings-options-formats">
                <h6 class="mb-3 d-flex align-items-center">
                  <i class="ico ico-format mr-4"></i>
                  <span>форматы</span>
                </h6>
                <Container :behaviour="'copy'" group-name="formats">
                  <Draggable v-for="format in formats" :key="format.id" class="product-settings-option-item">
                    <span>{{format.name}}</span>
                    <i class="fa fa-times" @click="deleteFormat(format.id)"></i>
                  </Draggable>
                </Container>
                <div class="new-options-format">
                  <form class="form-inline mt-2">
                    <input type="text" class="form-control form-control-sm w-50 mr-2" v-model="newFormat.name">
                    <button type="button" class="btn btn-sm btn-secondary px-3 mr-1" @click="clearNewFormat"><i class="fa fa-times"></i></button>
                    <button type="button" class="btn btn-sm btn-primary px-3" @click="saveFormat"><i class="fa fa-check"></i></button>
                    <br>
                    <br>
                    <input type="text" class="form-control form-control-sm" v-model="newFormat.width">
                    <span class="mx-1">x</span>
                    <input type="text" class="form-control form-control-sm" v-model="newFormat.height">
                    <span class="ml-1">мм</span>
                  </form>
                </div>
              </div>
              <div class="product-settings-options-operations mt-4">
                <h6 class="mb-3 d-flex align-items-center">
                  <i class="ico ico-template mr-4"></i>
                  <span>шаблоны</span>
                </h6>
                 <Container :behaviour="'copy'" group-name="operation">
                  <Draggable v-for="operation in operations" :key="operation.id" class="product-settings-option-item">
                  <span>{{operation.name}}</span>
                 </Draggable>
                </Container>
              </div>
              <div class="product-settings-options-counter mt-4">
                 <h6 class="mb-3 d-flex align-items-center">
                  <i class="ico ico-operations mr-4"></i>
                  <span>количество операций</span>
                </h6>
                <Container :behaviour="'copy'" group-name="operationCounter">
                  <Draggable v-for="count in operationsCount" :key="count.value" class="product-settings-option-item">
                  <span>{{count.name}}</span>
                  </Draggable>
                </Container>
              </div>
               <div class="product-settings-options-counter mt-4">
                 <h6 class="mb-3 d-flex align-items-center">
                  <i class="fa fa-retweet mr-4"></i>
                  <span>ориентация</span>
                </h6>
                <Container :behaviour="'copy'" group-name="orientation">
                  <Draggable class="product-settings-option-item">
                   <span>{{orientations.short}}</span>
                  </Draggable>
                  <Draggable class="product-settings-option-item">
                    <span>{{orientations.long}}</span>
                  </Draggable>
                </Container>
              </div>
               <div class="product-settings-options-counter mt-4">
                 <h6 class="mb-3 d-flex align-items-center">
                  <i class="fa fa-crop mr-4"></i>
                  <span>сторона обработки</span>
                </h6>
                <Container :behaviour="'copy'" group-name="processingSide">
                  <Draggable class="product-settings-option-item">
                   <span>{{processingSides.short}}</span>
                  </Draggable>
                  <Draggable class="product-settings-option-item">
                    <span>{{processingSides.long}}</span>
                  </Draggable>
                </Container>
              </div>
            </div>
            <div class="col product-settings-blocks">
              <div class="row">
                <div class="col-9">
                  <div class="product-settings-block mt-2" v-for="section in sections" :key="section.id">
                    <div class="product-settings-block__title d-flex align-items-center justify-content-between px-4">
                        <div>
                          <input type="text" class="form-control" v-model="section.name" v-if="section.isInEdit">
                          <h5 v-else>{{section.name}}</h5>
                        </div>
                        <div v-if="section.isInEdit">
                          <button type="button" class="btn btn-sm btn-outline-primary px-3" @click="cancelEditSection(section.id)">
                            <i class="fa fa-times"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-primary px-3 ml-2" @click="saveEditedSection(section.id)">
                            <i class="fa fa-check"></i>
                          </button>
                        </div>
                        <div v-else>
                          <button type="button" class="btn btn-sm btn-outline-primary px-3" @click="deleteSection(section.id)">
                            <i class="ico ico-delete"></i>
                          </button>
                          <button type="button" class="btn btn-sm btn-primary px-3 ml-2" @click="editSection(section.id)">
                            <i class="fa fa-pencil"></i>
                          </button>
                        </div>
                    </div>
                    <div class="product-settings-block__settings">
                      <div class="product-settings-block__settings-block  m-4" v-for="block in section.blocks" :key="block.id">
                          <div class="product-settings-block__settings-block-title d-flex align-items-center justify-content-between p-4">
                            <div class="w-75">
                              <div class="d-flex flex-column" v-if="block.isInEdit">
                                <span>Имя блока:</span>
                                <input type="text" class="form-control" v-model="block.name" >
                                <span class="mt-2">Алгоритм:</span>
                                <select class="form-control custom-select" v-model="block.algorithm" @change="onChangeAlgorithm(block)">
                                  <option v-for="algorithm in algorithms" :key="algorithm.id" :value="algorithm" :selected="algorithm.id === block.algorithm.id">{{ algorithm.name }}</option>
                                </select>
                              </div>
                              <h6 v-else>
                                <span>{{block.name}}</span>
                                <span class="ml-5">Алгоритм: {{block.algorithm.name }}</span>
                              </h6>
                            </div>
                            <div v-if="block.isInEdit">
                              <button type="button" class="btn btn-sm btn-outline-primary px-3" @click="cancelEditBlock(section.id, block.id)">
                                <i class="fa fa-times"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-primary px-3 ml-2" @click="saveEditedBlock(section.id, block.id)">
                                <i class="fa fa-check"></i>
                              </button>
                            </div>
                            <div v-else>
                              <button type="button" class="btn btn-sm btn-outline-primary px-3" @click="deleteBlock(section.id, block.id)">
                                <i class="ico ico-delete"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-primary px-3 ml-2" @click="editBlock(section.id, block.id)">
                                <i class="fa fa-pencil"></i>
                              </button>
                              <button type="button" class="btn btn-sm btn-outline-primary ml-2 px-3" v-if="block.position && section.isInEdit" @click="changeBlockPosition(section.id, block.id)">
                                <i class="fa fa-level-up"></i>
                              </button>
                            </div>
                          </div>
                          <div class="product-settings-block__settings-block-elements my-2 px-4">
                              <div v-if="block.algorithm.id === 17 && block.isInEdit" class="d-flex mb-2">
                                <label class="mr-2">Округление:</label>
                                <div class="custom-control custom-radio">
                                  <input type="radio" :id="block.id + round.floor" :name="block.id + 'customRadio'" :value="round.floor" class="custom-control-input" v-model="block.round">
                                  <label class="custom-control-label" :for="block.id + round.floor">В меньшую</label>
                                </div>
                                <div class="custom-control custom-radio ml-2">
                                  <input type="radio" :id="block.id + round.ceil" :name="block.id + 'customRadio'" :value="round.ceil" class="custom-control-input" v-model="block.round">
                                  <label class="custom-control-label" :for="block.id + round.ceil">В большую</label>
                                </div>
                              </div>
                              <template v-if="block.algorithm.id === 6">
                                <div class="product-settings-block__element" v-for="element in block.formats" :key="element.name">
                                    <div class="product-settings-block__element-name">
                                      {{element.name}}
                                    </div>
                                    <i class="fa fa-times" v-if="block.isInEdit" @click="deleteBlockFormat(section.id, block.id, element.name)"></i>
                                </div>
                              </template>
                              <Container class="product-settings-block__fromats-drop my-2 p-3" group-name="formats" v-show="block.algorithm.id === 6 && block.isInEdit"  @drop="onDropFormat($event, section.id, block.id)">
                                Форматы
                              </Container>
                              <div class="product-settings-block__element" v-if="block.operation && (block.algorithm.id !== 6 && block.algorithm.id !== 10)">
                                  <div class="product-settings-block__element-name" v-if="!block.operationForEdit">
                                   {{block.operation.name}} <i class="fa fa-pencil pl-3 cursor-pointer" v-show="block.isInEdit && block.operation.children" @click="editBlockOperation(section.id, block.id)"></i>
                                  </div>
                                  <div class="product-settings-block__element-select" v-else>
                                    <ProductOperationsSelect @saveProductOperationSettings="saveEditBlockOperation(section.id, block.id)" @cancelProductOperationSettings="cancelEditBlockOperation(section.id, block.id)" :operation="block.operationForEdit"/>
                                  </div>
                                  <i class="fa fa-times" v-if="block.isInEdit" @click="deleteBlockOperation(section.id, block.id, block.operation.name)"></i>
                              </div>
                              <Container class="product-settings-block__fromats-drop my-2" group-name="operation" v-show="(block.algorithm.id !== 6 && block.algorithm.id !== 10 && block.algorithm.id !== 27) && block.isInEdit && !block.operation"  @drop="onDropOperation($event, section.id, block.id)">
                                Шаблоны
                              </Container>
                              <template v-if="block.operation && (block.operation.algorithm.id === 2 || block.operation.algorithm.id === 3 || block.operation.algorithm.id === 5 || block.operation.algorithm.id === 18 || block.operation.algorithm.id === 19 || block.operation.algorithm.id === 23 || block.operation.algorithm.id === 25)">
                                <div class="product-settings-block__element" v-for="counter in block.operationCounter" :key="counter.name">
                                  <div class="product-settings-block__element-name">
                                    {{counter.name}}
                                  </div>
                                  <i class="fa fa-times" v-if="block.isInEdit" @click="deleteBlockOperationCounter(section.id, block.id, counter.name)"></i>
                                </div>
                              </template>
                              <Container class="product-settings-block__fromats-drop my-2" group-name="operationCounter" v-show="block.isInEdit && block.operation && (block.operation.algorithm.id === 2 || block.operation.algorithm.id === 3 || block.operation.algorithm.id === 5 || block.operation.algorithm.id === 18 || block.operation.algorithm.id === 19|| block.operation.algorithm.id === 23 || block.operation.algorithm.id === 25)"  @drop="onDropBlockOperationCounter($event, section.id, block.id)">
                                Количество операций
                              </Container>
                              <template v-if="block.algorithm.id === 10">
                                <div class="product-settings-block__element"  v-for="orient in block.orientation" :key="orient">
                                    <div class="product-settings-block__element-name">
                                      {{orientations[orient]}}
                                    </div>
                                    <i class="fa fa-times" v-if="block.isInEdit" @click="deleteBlockOrientation(section.id, block.id, orient)"></i>
                                </div>
                              </template>
                              <Container class="product-settings-block__fromats-drop my-2 p-3" group-name="orientation" v-show="block.algorithm.id === 10 && block.isInEdit"  @drop="onDropBlockOrientation($event, section.id, block.id)">
                                Ориентация
                              </Container>
                              <template v-if="block.algorithm.id === 17">
                                <div class="product-settings-block__element" v-for="processingSide in block.processingSides" :key="processingSide">
                                    <div class="product-settings-block__element-name">
                                      {{processingSides[processingSide]}}
                                    </div>
                                    <i class="fa fa-times" v-if="block.isInEdit" @click="deleteBlockProcessingSide(section.id, block.id, processingSide)"></i>
                                </div>
                              </template>
                              <Container class="product-settings-block__fromats-drop my-2 p-3" group-name="processingSide" v-show="block.algorithm.id === 17 && block.isInEdit"  @drop="onDropBlockProcessingSide($event, section.id, block.id)">
                                Сторона обработки
                              </Container>
                              <textarea rows="2" placeholder="Добавить описание" class="rounded d-block w-100"  style="resize: none;" v-if="block.isInEdit" v-model="block.description"></textarea>
                          </div>
                      </div>
                    </div>
                    <div class="px-4 py-4" v-if="section.isInEdit && !section.blocks.some(x=>x.id === null)">
                      <button type="button" class="btn btn-outline-primary" @click="addBlock(section.id)" :class="{'invisible': !section.id}">+ добавить блок</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-4" v-if="!sectionInEdit">
                <div class="col-9">
                  <button type="button" class="btn btn-outline-primary " @click="addNewSection">+ добавить раздел</button>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api'
import { Container, Draggable } from 'vue-smooth-dnd'
import ProductOperationsSelect from './ProductOperationsSelect'
import { sortBy } from 'lodash'

const getNewFormat = () => {
  return {
    name: '',
    width: null,
    height: null
  }
}

const getNewSection = () => {
  return {
    id: null,
    name: '',
    blocks: [],
    isInEdit: true
  }
}

const mapBlock = block => {
  return {
    id: block.id,
    name: block.name,
    algorithm: block.algorithm,
    formats: (block.formats || []).map(format => {
      return {
        name: format.name || 'Другое',
        width: format.width,
        height: format.height
      }
    }),
    operation: block.operation,
    operationCounter: (block.operation_counter || []).map(counter => {
      return {
        name: counter || 'Другое',
        value: counter
      }
    }),
    orientation: block.orientation || [],
    processingSides: block.processing_sides || [],
    round: block.round || null,
    isInEdit: false,
    description: block.description,
    position: block.position
  }
}

const mapsSection = section => {
  let blocks = !section.blocks ? [] : section.blocks.map(mapBlock)

  if (blocks.every(x => x.position === 0)) {
    blocks.forEach((x, index) => {
      x.position = index
    })
  }

  if (blocks.length) {
    blocks = blocks.sort((f, s) => f.position - s.position)
  }

  return {
    id: section.id,
    name: section.name,
    blocks,
    isInEdit: false
  }
}

const getNewBlock = (algorithm, position) => {
  return {
    id: null,
    name: '',
    algorithm: algorithm,
    formats: [],
    operation: null,
    operationCounter: [],
    orientation: [],
    processingSides: [],
    round: null,
    isInEdit: true,
    description: '',
    position: position || 0
  }
}

const getOperationsCount = () => {
  var result = [...Array(6).keys()].map(i => {
    return {
      name: (++i).toString(),
      value: i
    }
  })

  result.push({ name: 'Другое', value: null })

  return result
}

export default {
  name: 'ProductSettings',
  components: { Container, Draggable, ProductOperationsSelect },
  props: {
    printMachineId: {
      default: null
    },
    productId: {
      default: null
    }
  },
  data: () => {
    return {
      product: null,
      formats: [],
      operations: [],
      operationsCount: getOperationsCount(),
      newFormat: getNewFormat(),
      sections: [],
      algorithms: [],
      orientations: { long: 'По длинной стороне', short: 'По короткой стороне' },
      processingSides: { long: 'Длинная', short: 'Короткая' },
      round: { ceil: 'ceil', floor: 'floor' }
    }
  },
  methods: {
    loadPrintMachineProduct () {
      api.get
        .printMachineProduct(this.printMachineId, this.productId)
        .then(resp => {
          this.product = resp.data.data.product
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    loadPrintMachineOperations () {
      api.get
        .printMachineOperations(this.printMachineId)
        .then(resp => {
          this.operations = sortBy(resp.data.data.operations, (operation) => operation.name.toLowerCase()).filter((operation) => operation.enabled)
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    loadFormats () {
      api.get
        .loadPrintMachineFormats(this.printMachineId)
        .then(resp => {
          this.formats = resp.data.data.formats
          this.formats.push({ name: 'Другое', width: null, height: null })
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    loadPrintMachineProductSections () {
      api.get
        .printMachineProductSections(this.printMachineId, this.productId)
        .then(resp => {
          this.sections = resp.data.data.sections.map(mapsSection)
        })
    },
    loadPrintMachineProductAlgorithms () {
      api.get.loadProductAlgorithms().then(resp => {
        this.algorithms = resp.data.data.algorithms
      })
    },
    clearNewFormat () {
      this.newFormat = getNewFormat()
    },
    saveFormat () {
      api.post
        .savePrintMachineFormat(this.printMachineId, this.newFormat)
        .then(resp => {
          this.newFormat = getNewFormat()
          this.loadFormats()
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    deleteFormat (formatId) {
      api.get
        .deletePrintMachineFormat(this.printMachineId, formatId)
        .then(resp => {
          this.loadFormats()
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    addNewSection () {
      const section = getNewSection()
      this.sections.push(section)
    },
    deleteSection (sectionId) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.get
                .deletePrintMachineProductSections(
                  this.printMachineId,
                  this.productId,
                  sectionId
                )
                .then(resp => {
                  const index = this.sections.findIndex(x => x.id === sectionId)
                  this.sections.splice(index, 1)
                  this.$modal.hide('dialog')
                })
            }
          }
        ]
      })
    },
    editSection (sectionId) {
      const section = this.sections.find(x => x.id === sectionId)
      section.isInEdit = true
    },
    saveEditedSection (sectionId) {
      const section = this.sections.find(x => x.id === sectionId)
      const index = this.sections.findIndex(x => x.id === sectionId)
      let newSection
      if (!sectionId) {
        api.post
          .createPrintMachineProductSection(
            this.printMachineId,
            this.productId,
            section.name
          )
          .then(resp => {
            newSection = mapsSection(resp.data.data.section)
            newSection.isInEdit = true
            this.sections.splice(index, 1, newSection)
          })
      } else {
        api.post
          .updatePrintMachineProductSection(
            this.printMachineId,
            this.productId,
            sectionId,
            section.name
          )
          .then(resp => {
            // newSection = mapsSection(resp.data.data.section)
            newSection = this.sections.find(x => x.id === sectionId)
            newSection.isInEdit = false
            this.sections.splice(index, 1, newSection)
          })
      }
      section.blocks.forEach(block =>
        api.post.updatePrintMachineProductSectionBlockPosition(this.printMachineId, this.productId, sectionId, block.id, block.position))
    },
    cancelEditSection (sectionId) {
      const index = this.sections.findIndex(x => x.id === sectionId)
      if (!sectionId) {
        this.sections.splice(index, 1)
      } else {
        api.get
          .printMachineProductSection(
            this.printMachineId,
            this.productId,
            sectionId
          )
          .then(resp => {
            const section = mapsSection(resp.data.data.section)
            this.sections.splice(index, 1, section)
          })
      }
    },
    addBlock (sectionId) {
      const section = this.sections.find(x => x.id === sectionId)
      section.blocks.push(getNewBlock(this.algorithms[0], section.blocks.length))
    },
    deleteBlock (sectionId, blockId) {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              const section = this.sections.find(x => x.id === sectionId)
              const index = section.blocks.findIndex(x => x.id === blockId)
              api.get
                .deletePrintMachineProductSectionsBlock(
                  this.printMachineId,
                  this.productId,
                  sectionId,
                  blockId
                )
                .then(resp => {
                  section.blocks.splice(index, 1)
                  this.$modal.hide('dialog')

                  section.blocks = section.blocks.map((x, index) => { return { ...x, position: index } })
                })
            }
          }
        ]
      })
    },
    editBlock (sectionId, blockId) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      block.isInEdit = true
    },
    changeBlockPosition (sectionId, blockId) {
      const section = this.sections.find(x => x.id === sectionId)
      let sectionBlocks = section.blocks.slice(0)

      const block = sectionBlocks.find(x => x.id === blockId)
      const blockIndex = sectionBlocks.findIndex(x => x.id === block.id)
      const blockPosition = block.position

      const prevBlock = section.blocks[blockIndex - 1]

      block.position = blockPosition - 1
      prevBlock.position = blockPosition

      sectionBlocks = sectionBlocks.sort((f, s) => f.position - s.position)

      section.blocks = sectionBlocks
    },
    getEditedBlock (block) {
      function flatten (arr) {
        return arr.reduce(function (flat, toFlatten) {
          return flat.concat(
            Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
          )
        }, [])
      }
      function getActiveOperationsIds (operation) {
        let result = []
        if (operation.children) {
          result = operation.children.map(x => {
            return getActiveOperationsIds(x)
          })
        }
        if (
          typeof operation.checked !== 'boolean' ||
          (typeof operation.checked === 'boolean' && operation.checked)
        ) {
          result.push(operation.id)
        }
        return flatten(result)
      }
      return {
        name: block.name,
        algorithm: block.algorithm.id,
        operation: block.operation
          ? {
            id: block.operation.id,
            children: block.operation.children
              ? flatten(
                block.operation.children.map(x => getActiveOperationsIds(x))
              )
              : undefined
          }
          : null,
        formats:
          block.formats.length > 0
            ? block.formats.map(format => {
              return {
                height: format.height,
                name:
                    format.height === null || format.width === null || format.height === '' || format.width === ''
                      ? null
                      : format.name,
                width: format.width
              }
            })
            : undefined,
        operation_counter:
          block.operationCounter.length > 0
            ? block.operationCounter.map(x => x.value)
            : null,
        orientation:
          block.orientation.length > 0
            ? block.orientation
            : null,
        processing_sides:
          block.processingSides.length > 0
            ? block.processingSides
            : null,
        round: block.round ? block.round : null,
        description: block.description,
        position: block.position
      }
    },
    saveEditedBlock (sectionId, blockId) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const savedBlock = this.getEditedBlock(block)
      if (!blockId) {
        api.post
          .createPrintMachineProductSectionBlock(
            this.printMachineId,
            this.productId,
            sectionId,
            savedBlock
          )
          .then(resp => {
            this.updateSectionBlock(
              sectionId,
              blockId,
              resp.data.data.block.id
            )
          })
      } else {
        api.post
          .updatePrintMachineProductSectionBlock(
            this.printMachineId,
            this.productId,
            sectionId,
            blockId,
            savedBlock
          )
          .then(resp => {
            this.updateSectionBlock(sectionId, blockId, blockId)
          })
      }
    },
    cancelEditBlock (sectionId, blockId) {
      if (!blockId) {
        const section = this.sections.find(x => x.id === sectionId)
        const index = section.blocks.findIndex(x => x.id === blockId)
        section.blocks.splice(index, 1)
      } else {
        this.updateSectionBlock(sectionId, blockId, blockId)
      }
    },
    onChangeAlgorithm (block) {
      if (block.algorithm.id === 17) {
        block.round = block.round || this.round.floor
      } else {
        block.round = null
      }
    },
    editBlockOperation (sectionId, blockId) {
      const section = this.sections.find(x => x.id === sectionId)
      const index = section.blocks.findIndex(x => x.id === blockId)
      const block = section.blocks[index]
      block.operationForEdit = JSON.parse(JSON.stringify(block.operation))
      section.blocks.splice(index, 1, block)
    },
    saveEditBlockOperation (sectionId, blockId) {
      const section = this.sections.find(x => x.id === sectionId)
      const index = section.blocks.findIndex(x => x.id === blockId)
      const block = section.blocks[index]
      block.operation = block.operationForEdit
      section.blocks.splice(index, 1, block)
      delete block.operationForEdit
    },
    cancelEditBlockOperation (sectionId, blockId) {
      const section = this.sections.find(x => x.id === sectionId)
      const index = section.blocks.findIndex(x => x.id === blockId)
      const block = section.blocks[index]
      delete block.operationForEdit
      section.blocks.splice(index, 1, block)
    },
    updateSectionBlock (sectionId, blockId, newBlockId) {
      const section = this.sections.find(x => x.id === sectionId)
      const index = section.blocks.findIndex(x => x.id === blockId)
      api.get
        .printMachineProductSection(
          this.printMachineId,
          this.productId,
          sectionId
        )
        .then(resp => {
          const block = mapsSection(resp.data.data.section).blocks.find(
            x => x.id === newBlockId
          )
          section.blocks.splice(index, 1, block)
        })
    },
    onDropFormat (event, sectionId, blockId) {
      if (event.addedIndex === null) return
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const formatName = event.droppedElement.textContent
      if (!block.formats.some(x => x.name === formatName)) {
        block.formats.push(this.formats.find(x => x.name === formatName))
      }
      block.operation = null
      block.operationCounter = []
      block.orientation = []
      block.processingSides = []
    },
    onDropOperation (event, sectionId, blockId) {
      if (event.addedIndex === null) return
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const operationName = event.droppedElement.textContent
      if (!block.operation) {
        block.operation = this.operations.find(x => x.name === operationName)
      }
      block.formats = []
      block.operationCounter = []
      block.orientation = []
      block.processingSides = []
    },
    onDropBlockOperationCounter (event, sectionId, blockId) {
      if (event.addedIndex === null) return
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const counterName = event.droppedElement.textContent
      if (!block.operationCounter.some(x => x.name === counterName)) {
        block.operationCounter.push(
          this.operationsCount.find(x => x.name === counterName)
        )
      }
      block.formats = []
      block.orientation = []
      block.processingSides = []
    },
    onDropBlockOrientation (event, sectionId, blockId) {
      if (event.addedIndex === null) return
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const orientationName = event.droppedElement.textContent
      const orientation = Object.keys(this.orientations).find(x => this.orientations[x] === orientationName)
      if (!block.orientation.some(x => x === orientation)) {
        block.orientation.push(
          orientation
        )
      }
      block.formats = []
      block.operation = null
      block.operationCounter = []
      block.processingSides = []
    },
    onDropBlockProcessingSide (event, sectionId, blockId) {
      if (event.addedIndex === null) return
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const processingSideName = event.droppedElement.textContent
      const processingSide = Object.keys(this.processingSides).find(x => this.processingSides[x] === processingSideName)
      if (!block.processingSides.some(x => x === processingSide)) {
        block.processingSides.push(
          processingSide
        )
      }
      block.formats = []
      block.operationCounter = []
      block.orientation = []
    },
    deleteBlockFormat (sectionId, blockId, name) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const formatIndex = block.formats.findIndex(x => x.name === name)
      block.formats.splice(formatIndex, 1)
    },
    deleteBlockOperation (sectionId, blockId, name) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      block.operation = null
    },
    deleteBlockOperationCounter (sectionId, blockId, name) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const counterIndex = block.operationCounter.findIndex(x => x.name === name)
      block.operationCounter.splice(counterIndex, 1)
    },
    deleteBlockOrientation (sectionId, blockId, orientation) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const orientationIndex = block.orientation.findIndex(x => x === orientation)
      block.orientation.splice(orientationIndex, 1)
    },
    deleteBlockProcessingSide (sectionId, blockId, processingSide) {
      const block = this.sections
        .find(x => x.id === sectionId)
        .blocks.find(x => x.id === blockId)
      const processingSideIndex = block.processingSides.findIndex(x => x === processingSide)
      block.processingSides.splice(processingSideIndex, 1)
    },
    cancel () {
      this.$router.push({ path: this.backLink })
    },
    save () {
      this.$router.push({ path: this.backLink })
    }
  },
  computed: {
    backLink () {
      return `/settings/print-machine-products/${
        this.printMachineId
      }/product-card/${this.productId}`
    },
    sectionInEdit () {
      return this.sections.some(x => x.isInEdit)
    }
  },
  created: function () {
    this.loadPrintMachineProductAlgorithms()
    this.loadPrintMachineOperations()
    this.loadPrintMachineProduct()
    this.loadFormats()
    this.loadPrintMachineProductSections()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки содержания продуктов')
    })
  }
}
</script>

<style lang="scss" scoped>
.product-settings-options {
  max-width: 260px;
}

.product-settings-options-formats,
.product-settings-options-operations,
.product-settings-options-counter {
  padding: 10px;
  border-radius: 4px;
  background-color: #f0f9f6;
  .ico,
  h6 {
    color: #959596;
  }
}

.product-settings-option-item {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  margin: 5px;
  padding: 8px 15px;
  color: #28bd8b;
  font-size: 14px;
  font-weight: bold;
  border: 2px dashed #28bd8b;
  border-radius: 3px;
  background: rgba(#000, 0);
  &:hover {
    cursor: pointer;
    color: #f0f9f6;
    border: 2px solid #28bd8b;
    background-color: #28bd8b;
    .fa-times {
      display: inline-block;
    }
  }

  .fa-times {
    display: none;
    font-size: 11px;
    padding: 3px 5px;
    position: absolute;
    color: #28bd8b;
    top: -8px;
    right: -8px;
    background-color: #ffffff;
    border-radius: 30px;
  }
}

.new-options-format {
  .form-control {
    max-width: 85px;
  }
}

.product-settings-block {
  border-radius: 4px;
  border: 1px solid #dbe1e5;
  background-color: #f9f9f9;

  &__title {
    height: 50px;
    background-color: #ebeff1;
    .form-control {
      min-width: 400px;
    }
  }

  &__settings-block {
    background-color: #fff;
    border: 2px dashed #dbe1e5;
    border-radius: 3px;
  }

  &__element {
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    margin: 5px;
    padding: 8px 15px;
    font-size: 14px;
    font-weight: bold;
    border-radius: 3px;
    color: #f0f9f6;
    border: 2px solid #28bd8b;
    background-color: #28bd8b;
    width: auto;
    cursor: default;

    .fa-times {
      font-size: 11px;
      padding: 3px 5px;
      position: absolute;
      color: #28bd8b;
      top: -8px;
      right: -8px;
      background-color: #dbe1e5;
      border-radius: 30px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  &__fromats-drop {
    height: 50px;
    background-color: #ebeff1;
    border-radius: 3px;
  }
}

.smooth-dnd-draggable-wrapper {
  overflow: visible !important;
  display: inline-block !important;
}
</style>
